module.exports = __webpack_public_path__ + "img/logo.d18f9f94.png";